function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import { Kind } from "@oui/lib/src/types";
import { Button } from "./Button";
import { Checkbox } from "./Checkbox";
import { View } from "./View";
/**
 * A `ChatInput` variant that presents a list of choices to the user and allows
 * selection of exactly one choice.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-70}
 */ export var ChatInputSingleChoice = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ChatInputSingleChoice, Component);
    function ChatInputSingleChoice() {
        _class_call_check(this, ChatInputSingleChoice);
        var _this;
        _this = _call_super(this, ChatInputSingleChoice, arguments), _define_property(_this, "state", {
            checkedValue: ''
        });
        return _this;
    }
    _create_class(ChatInputSingleChoice, [
        {
            key: "handleSubmit",
            value: function handleSubmit(value) {
                var _this = this;
                if (this.state.checkedValue) return;
                var onInput = this.props.onInput;
                this.setState({
                    checkedValue: value
                });
                if (onInput) {
                    // Give the radio button a chance to show as checked before sending the event + hiding
                    setTimeout(function() {
                        if (_this.props.legacyChoice) {
                            onInput({
                                kind: Kind.InputChoice,
                                props: [
                                    Number(value)
                                ]
                            });
                        } else {
                            onInput({
                                kind: Kind.InputSingleChoice,
                                props: Number(value)
                            });
                        }
                    }, 500);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var style = this.props.style;
                var submit = function(val) {
                    return function() {
                        return _this.handleSubmit(val);
                    };
                };
                var numChoices = Object.entries(this.props.label).length;
                return /*#__PURE__*/ _jsx(View, {
                    style: [
                        {
                            paddingTop: 8,
                            paddingLeft: 16,
                            paddingBottom: 8,
                            paddingRight: 16
                        },
                        style
                    ],
                    children: /*#__PURE__*/ _jsx(View, {
                        spacing: 8,
                        row: this.props.variant === 'button',
                        style: this.props.variant === 'button' ? {
                            justifyContent: 'center',
                            flexWrap: 'wrap'
                        } : null,
                        "aria-label": numChoices === 1 ? undefined : this.props.lastTextContent,
                        role: numChoices === 1 ? 'none' : 'radiogroup',
                        children: Object.entries(this.props.label).map(function(param) {
                            var _param = _sliced_to_array(param, 2), i = _param[0], str = _param[1];
                            var isChosen = _this.state.checkedValue === i;
                            return _this.props.variant === 'button' ? /*#__PURE__*/ _jsx(Button, {
                                testID: "ChatInputSingleChoice_".concat(i),
                                onPress: submit(i),
                                text: str,
                                style: {
                                    marginVertical: 4
                                },
                                variant: isChosen ? 'solid' : 'contained'
                            }, i) : /*#__PURE__*/ _jsx(Checkbox, {
                                testID: "ChatInputSingleChoice_".concat(i),
                                horizontal: true,
                                onChangeValue: submit(i),
                                label: str,
                                variant: "radio",
                                value: isChosen
                            }, i);
                        })
                    })
                });
            }
        }
    ]);
    return ChatInputSingleChoice;
}(Component);
_define_property(ChatInputSingleChoice, "defaultProps", {
    label: {}
});
